module.exports = __webpack_public_path__ + "static/media/WNP.c5d2ca1d.jpg";